import { apiRoutes } from "../apiRoutes";
import waitlistAxios from "../waitlistAxios";

export const getJoinedCount = async () => {
  const response = await waitlistAxios.get(apiRoutes.JOINED_COUNT);
  return response.data;
};
